function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "color",
  points: "100.0,57.63923 162.99003,81.05572000000001 162.99003,118.94427999999999 138.92993,133.41642 99.99998,151.30498 61.07007,133.41642 37.00997,118.94427999999999 37.00997,81.05572000000001",
  stroke: "black"
});

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0,
  points: "100.0,57.63923 138.92993,133.41642 99.99998,151.30498 61.07007,133.41642",
  stroke: "black"
});

var _ref5 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.6,
  points: "100.0,57.63923 162.99003,81.05572000000001 162.99003,118.94427999999999 138.92993,133.41642",
  stroke: "black"
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.6,
  points: "100.0,57.63923 61.07007,133.41642 37.00997,118.94427999999999 37.00997,81.05572000000001",
  stroke: "black"
});

var SvgD10 = function SvgD10(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    baseProfile: "full",
    height: "200px",
    viewBox: "0 0 200 200",
    width: "200px",
    xmlnsev: "http://www.w3.org/2001/xml-events",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgD10, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/d10.ce325599.svg";
export { ForwardRef as ReactComponent };